var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.056 3.056a2.363 2.363 0 0 1 1.671-.692h7.09c.162 0 .316.064.43.177l5.212 5.214a.606.606 0 0 1 .178.428v11.09a2.364 2.364 0 0 1-2.364 2.363H6.727a2.363 2.363 0 0 1-2.363-2.364V4.728c0-.627.249-1.229.692-1.672Zm1.671.52a1.151 1.151 0 0 0-1.151 1.152v14.544a1.152 1.152 0 0 0 1.151 1.152h10.546a1.151 1.151 0 0 0 1.151-1.152V8.434l-4.857-4.858h-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.91 15 .295-.98h1.69l.295.98h1.5L12 9.88h-1.9L8.41 15h1.5Zm.61-2.02.51-1.69h.04l.51 1.69h-1.06ZM14.203 15h1.38v-3.84h-1.38V15Zm.69-4.24c.375 0 .68-.283.68-.63 0-.348-.305-.63-.68-.63-.375 0-.68.283-.68.63 0 .347.305.63.68.63Z"
  }))));
};
export default SvgAi;